import { LimitTariffsFromOperator } from "Constants/Limit";
import { useCallback } from "react";
import { useQuery } from "@apollo/client";
import { MOBILE_TAGS_QUERY, MOBILE_TARIFFS_QUERY_2 } from "Services/queries";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { useGetFilterFromParams } from "./useGetFilterFromParams";

export const useGetMobileTariffsQuery = ({ sort, skip = false, action = false }) => {
	const { params } = useWithDefaultParams();

	const { filter } = useGetFilterFromParams();
	const additionalFilters = [];

	if (params.tagCode) {
		additionalFilters.push(`mobile_new.tag_mobil.translit=${params.tagCode}`);
	}

	const tariffsQuery = useQuery(MOBILE_TARIFFS_QUERY_2, {
		skip,
		variables: {
			filter: `${filter}&${additionalFilters.join("&")}`,
			limit: LimitTariffsFromOperator,
			offset: 0,
			providerJoin: true,
			sort: sort,
			onlyActions: action,
		},
		notifyOnNetworkStatusChange: true,
	});

	const fetchMoreTariffs = useCallback(() => {
		tariffsQuery.fetchMore({
			variables: {
				offset: tariffsQuery.data.mobileTariffs.data.length,
			},
			updateQuery: (prev, { fetchMoreResult }) => {
				if (!fetchMoreResult) return prev;

				return Object.assign({}, prev, {
					mobileTariffs: {
						...prev.mobileTariffs,
						data: [...prev.mobileTariffs.data, ...fetchMoreResult.mobileTariffs.data],
					},
				});
			},
		});
	}, [tariffsQuery]);

	return {
		fetchMoreTariffs,
		isTariffsLoading: tariffsQuery.loading,
		tariffs: tariffsQuery?.data?.mobileTariffs?.data || [],
		totalTariffs: tariffsQuery?.data?.mobileTariffs?.pagination?.items_total,
	};
};

export const useGetMobileTagsQuery = (skip = false) => {
	const { params } = useWithDefaultParams();
	const { regionUrl } = params;

	const mobileTagsQuery = useQuery(MOBILE_TAGS_QUERY, {
		skip: skip,
		variables: {
			region_url: regionUrl,
			provider_url: params.operator,
			tag_type: "mobile",
		},
		notifyOnNetworkStatusChange: true,
	});

	return {
		isMobileTagsLoading: mobileTagsQuery.loading,
		mobileTags: mobileTagsQuery.data?.mobileTags?.data,
	};
};
